import { call } from "lib/http/call";
import { ServiceEndpoints } from "lib/http/constants";
import { MethodType } from "lib/http/types";
import { FullUserCredentialingDetails } from "./types";

export const getFullUserCredentialing = async () => {
  return await call<FullUserCredentialingDetails>({
    endpoint: `${ServiceEndpoints.MARITIMECREDENTIALING}/v1/users/credentialing`,
    method: MethodType.GET,
  });
};
